// extracted by mini-css-extract-plugin
export default {"tabLabels":"tabs_tabLabels__z-dL+","active":"tabs_active__psD02","tabs":"tabs_tabs__ZVYrr","hidden":"tabs_hidden__LoD76"};